import { FormSelectField } from 'containers/authorised/ATS/organisms/JobDetailForm/types'
import { GetJobAssessmentCardRes, JobAssessmentCard } from './types'

export const formatResponse = (response: GetJobAssessmentCardRes): JobAssessmentCard => {
  const cardOwners: FormSelectField[] = []
  const assessors: FormSelectField[] = []
  response.assessment_card.assessment_card_resources_attributes.forEach((resource) => {
    if (resource.resource_type === 'assessor') {
      assessors.push({
        label: resource.resource_type,
        value: resource.resource_id,
        id: resource.id,
      })
    } else {
      cardOwners.push({
        label: resource.resource_type,
        value: resource.resource_id,
        id: resource.id,
      })
    }
  })
  return {
    id: response.assessment_card.id,
    created_by_id: response.assessment_card?.created_by_id,
    is_assessor: response.assessment_card?.is_assessor,
    is_owner: response.assessment_card?.is_owner,
    job_id: response.assessment_card.job_id,
    title: response.assessment_card.title,
    assessment_card_resources_attributes: {
      assessors,
      card_owners: cardOwners,
    },
    assessment_skills_attributes: response.assessment_card.assessment_skills_attributes?.map(
      (skills) => {
        return {
          ...skills,
          job_workflow_stages: skills.job_workflow_stages?.map((stage) => {
            return {
              label: stage.stage_name_i18n,
              value: stage.id,
            }
          }),
        }
      },
    ),

    deleted_assessment_skills_attributes: [],
  }
}
